import {
    calcPolylineTrafficRadiusByZoomLevel
} from "@containers/map/containers/traffic/helpers/calcPolylineTrafficRadiusByZoomLevel";

export const getPointSizeByEntryRadiusSingleVoyage = ({
                                              entryRadius,
                                              zoomLevel,
                                          }: {
    entryRadius: number
    zoomLevel: number
}): number => {

    return calcPolylineTrafficRadiusByZoomLevel({
        radius: entryRadius,
        zoomLevel
    })


}